const sizes = {
  sm: { icon: 'w-7 h-7', text: 'text-lg', tagline: 'text-[8px]' },
  md: { icon: 'w-8 h-8 sm:w-9 sm:h-9', text: 'text-xl sm:text-2xl', tagline: 'text-[9px]' },
  lg: { icon: 'w-10 h-10 sm:w-[52px] sm:h-[52px]', text: 'text-2xl sm:text-3xl md:text-4xl', tagline: 'text-[10px] sm:text-xs' },
};

export function LogoMark({ size = 36, className = '' }) {
  const isTailwind = typeof size === 'string';
  return (
    <svg 
      viewBox="0 0 100 100" 
      xmlns="http://www.w3.org/2000/svg" 
      className={`text-current ${isTailwind ? size : ''} ${className}`}
      style={!isTailwind ? { width: size, height: size } : {}}
    >
      <defs>
        <linearGradient id="msmeCore" x1="36" y1="36" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#2563EB" />
          <stop offset="100%" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
      <g className="fill-current text-current">
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(0 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(45 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(90 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(135 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(180 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(225 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(270 50 50)" />
        <rect x="43.5" y="8" width="13" height="16" rx="4" transform="rotate(315 50 50)" />
      </g>
      <circle cx="50" cy="50" r="34" className="fill-current text-current" />
      <circle cx="50" cy="50" r="22" fill="none" stroke="currentColor" className="text-slate-300 dark:text-slate-800" strokeWidth="8" />
      <circle cx="50" cy="50" r="14" fill="url(#msmeCore)" />
    </svg>
  );
}

export function Logo({ size = 'md', showTagline = false, className = '' }) {
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2 sm:gap-2.5 text-slate-900 dark:text-white ${className}`}>
      <LogoMark size={s.icon} className="shrink-0 text-current" />
      <div className="flex flex-col leading-none">
        <span className={`font-black tracking-tight text-inherit`} style={{ fontFamily: "'Outfit', sans-serif" }}>
          <span className="text-inherit">{size === 'lg' ? 'MSME ' : 'MSME'} </span>
          <span className="bg-gradient-to-r from-blue-600 to-cyan-400 bg-clip-text text-transparent tracking-wide">Center</span>
        </span>
        {showTagline && (
          <span className={`${s.tagline} font-semibold uppercase tracking-widest text-slate-600 dark:text-slate-400 mt-1`}>
            Empowering Businesses. Enabling Growth.
          </span>
        )}
      </div>
    </div>
  );
}
